import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
const ClockBlack = (props) => (<Svg {...props}>
    <Path d="M9.167 1.667a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 0 0 0-16.666Zm0 15a6.666 6.666 0 1 1 0-13.333 6.666 6.666 0 0 1 0 13.333ZM9.167 5a.833.833 0 0 0-.834.833v3.684l-1.75 1.008A.833.833 0 0 0 7 12.083a.833.833 0 0 0 .417-.108l2.166-1.25.075-.075.134-.108a.718.718 0 0 0 .083-.134.741.741 0 0 0 .067-.141.542.542 0 0 0 .041-.167L10 10V5.833A.833.833 0 0 0 9.167 5Z" fill={props.fill ?? '#393360'}/>
  </Svg>);
export default ClockBlack;
